/// <reference path="../typings/tsd.d.ts" /> 
/// <reference path="../typings/angularjs/angular.d.ts" />
/// <reference path="../typings/angularjs/angular-route.d.ts" />

"use strict";

// Create and register modules
var modules = [
    "warsApp.controllers",
    "warsApp.services",
    "warsApp.factories",
    "warsApp.filters",
    "warsApp.directives"
];


modules.forEach((currentModule) => angular.module(currentModule, []));

// *** Push ngRoute or $routeProvider won't work ***
modules.push("ui.bootstrap");
modules.push("ngRoute");
modules.push("ngCookies");
modules.push("angular-growl");
modules.push("angular.filter");
modules.push("ngResource");
modules.push("ngSanitize");
modules.push("blockUI");
modules.push("breeze.angular");
modules.push("toggle-switch");
modules.push("angularModalService");
modules.push("breeze.directives");
modules.push("LocalStorageModule");
modules.push("xeditable");
modules.push("angular-sortable-view");
modules.push("ui.ace");
modules.push("ngJsTree");
modules.push("ngDragDrop");
modules.push("ngFileUpload");
modules.push("ui.tinymce");
modules.push("colorpicker.module");
modules.push("ui.mask");
//modules.push("uiGmapgoogle-maps");
modules.push("ui.bootstrap-slider");
modules.push("jsonFormatter");
modules.push("ngTagsInput");
modules.push("ngAnimate");
modules.push("frapontillo.gage");

var app = angular.module('warsApp', modules);

//TODO: do not delete - this needs to be done, but requires the implementation of a synchronous http request in field.ts fieldchangedinternal()
//app.factory('beforeUnload', ["$rootScope", "$window", ($rootScope, $window) => {
//        // Events are broadcast outside the Scope Lifecycle
//        $window.onbeforeunload = e => {
//            $rootScope.$broadcast('onBeforeUnload');
//        };
//        return {};
//    }
//]);
//app.run(beforeUnload => {
//    // Must invoke the service at least once
//});

app.run(["breeze", breeze => { }]);
app.run(["editableOptions", editableOptions => {
    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
}]);

app.config(['growlProvider', growlProvider => {
    growlProvider.globalPosition('top-center');
}]);

app.config(['localStorageServiceProvider', localStorageServiceProvider => {
    localStorageServiceProvider.setStorageType('sessionStorage');
}]);

//app.config(["uiGmapGoogleMapApiProvider", uiGmapGoogleMapApiProvider => {
//    uiGmapGoogleMapApiProvider.configure({
//        key: 'AIzaSyA4Wfku2a5uTM89QuwJHrvXAfAT1q56ApE',
//        v: '3.20', //defaults to latest 3.X anyhow
//        libraries: 'weather,geometry,visualization'
//    });
//}]);

var serviceBase = window.location.protocol + "//" + window.location.host + window.location.pathname;
var length = serviceBase.length;
if (serviceBase[length - 1] !== "/") serviceBase += "/";

localStorage.setItem('baseUrl', serviceBase);
app.constant('ngAuthSettings', {
    apiServiceBaseUri: serviceBase,
    clientId: '89740123880-t1le136djqfmeeu3o1ahu2qrh9jelggt.apps.googleusercontent.com'
});

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
}]);

// Log out the user when application loads.  Just doing this so regening the db doesn't cause issues.
//app.run(['authService', authService => { authService.logOut(); }]);

module warsApp {


    // *** Modules need to be populated to be correctly defined, otherwise they will give warnings. null fixes this ***/
    export module controllers {
        null;
    }

    export module directives {
        null;
    }

    export module factories {
        null;
    }

    export module filters {
        null;
    }

    export module services {
        null;
    }

    export module models{
        null;
    }

    export interface IController {
    }

    export interface IDirective {
        restrict: string;
        link($scope: ng.IScope, element: JQuery, attrs: ng.IAttributes, controller: IController): any;
    }

    export interface IFilter {
        filter(input: any, ...args: any[]): any;
    }

    export interface IService {
    }

    // Call constructor with arguments in args array split out
    function construct(constructorFunction, args) {
        function F(): void {
            constructorFunction.apply(this, args);
        }
        F.prototype = constructorFunction.prototype;
        return new F();
    }

    /**
     * Register new controller.
     *
     * @param className
     * @param services
     */
    export function registerController(className: string, services = []) {
        var controller = className[0].toLowerCase() + className.slice(1);
        services.push(warsApp.controllers[className]);
        angular.module("warsApp.controllers").controller(controller, services);
    }

    /**
     * Register new filter.
     *
     * @param className
     * @param services
     */
    export function registerFilter(className: string, services = []) {
        var filterFunctionName = className[0].toLowerCase() + className.slice(1);
        services.push(
            (...filterDependencies: any[]) => {
                var realInstance = construct(warsApp.filters[className], filterDependencies);
                return (...filterArguments: string[]) => {
                    return realInstance.filter.apply(realInstance, filterArguments);
                }
            });
        angular.module("warsApp.filters").filter(filterFunctionName, services);
    }

    
    /**
     * Register new directive.
     *
     * @param className
     * @param services
     */
    export function registerDirective(className: string, services = []) {
        var directive = className[0].toLowerCase() + className.slice(1);
        services.push(function () { return construct(warsApp.directives[className], arguments); });
        angular.module("warsApp.directives").directive(directive, services);
    }

    /**
     * Register new service.
     *
     * @param className
     * @param services
     */
    export function registerService(className: string, services = []) {
        var service = className[0].toLowerCase() + className.slice(1);
        services.push(function () { return construct(warsApp.services[className], arguments); });
        angular.module("warsApp.services").factory(service, services);
    }
}
breeze.NamingConvention.camelCase.setAsDefault();

var warsBreeze = {
    entityManager: new breeze.EntityManager("breeze/breeze")
};

angular.element(document).ready(() => { angular.bootstrap(document, ['warsApp']); });

(function () {
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("Condition", warsApp.models.Condition);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("ObjectSchema", warsApp.models.ObjectSchema);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("SchemaProperty", warsApp.models.SchemaProperty);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("DataOperation", warsApp.models.DataOperation);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("FormSection", warsApp.models.FormSection);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("ValueOperation", warsApp.models.ValueOperation);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("ObjectQueryPredicate", warsApp.models.ObjectQueryPredicate);
    warsBreeze.entityManager.metadataStore.registerEntityTypeCtor("ObjectQueryProjection", warsApp.models.ObjectQueryProjection);
    //warsBreeze.entityManager.metadataStore.fetchMetadata("breeze/Breeze")
    //.then((rawMetadata) => {
    //    angular.element(document).ready(() => {
    //        angular.bootstrap(document, ['warsApp']);
    //    });
    //},(failureReason) => {
    //    alert(failureReason);
    //});

})();